<template>
  <div class="contract-info-bd">
    <!-- <div class="title">{{ $t('page_contract_he_tong_xin_xi') }}</div> -->
    <div class="info-wrap">
      <div class="item-onfo">
        <h1 class="sub-title">{{ $t('crm_contract_info.ji_chu_xin_xi') }}</h1>
        <ul class="ubw">
          <li>
            <span class="label" v-if="bizClassType === 'contract'">{{ $t('crm_contract_info.he_tong_zhuang_tai') }}：</span>
            <span class="label" v-if="bizClassType === 'order'">{{ $t('crm_contract_info.ding_dan_zhuang_tai') }}：</span>
            <span>{{ getDicValue('crm_contract_biz_state', detail.bizState) }}</span>
          </li>
          <li>
            <span class="label" v-if="bizClassType === 'contract'">{{ $t('crm_contract_info.he_tong_lei_xing') }}：</span>
            <span class="label" v-if="bizClassType === 'order'">{{ $t('crm_contract_info.ding_dan_lei_xing') }}：</span>
            <span>{{ getDicValue('crm_contract_type', detail.bizClass) }}</span>
          </li>
          <li>
            <span class="label">{{ $t('crm_contract_info.qian_ding_ri_qi') }}：</span>
            <span>{{ $momentLocal(detail.signingDate, 'YYYY-MM-DD') || '/' }}</span>
          </li>
          <li>
            <span class="label" v-if="bizClassType === 'contract'">{{ $t('crm_contract_info.he_tong_bian_hao') }}：</span>
            <span class="label" v-if="bizClassType === 'order'">{{ $t('crm_contract_info.ding_dan_bian_hao') }}：</span>
            <span>{{ detail.contractNo }}</span>
          </li>
          <li>
            <span class="label">{{ $t('crm_contract_info.sghth') }}：</span>
            <span>{{ detail.customContractNo }}</span>
          </li>
          <li>
            <span class="label">{{ $t('crm_contract_info.jiao_huo_ri_qi') }}：</span>
            <span>{{ $momentLocal(detail.deliveryDate, 'YYYY-MM-DD') }}</span>
          </li>
          <li>
            <span class="label">{{ $t('crm_contract_info.ying_yong_chang_jing') }}：</span>
            <span>{{ getDicValue('crm_contract_usage_scene', detail.usageScene) }}</span>
          </li>
          <li>
            <span class="label">{{$t('crm_contract_info.ssxmqy')}}：</span>
            <span>{{ getLocationNameAndSiteName(detail) }}</span>
          </li>
          <li>
            <span class="label" v-if="bizClassType === 'contract'">{{ $t('crm_contract_info.he_tong_ya_jin') }}：</span>
            <span class="label" v-if="bizClassType === 'order'">{{ $t('crm_contract_info.ding_dan_ya_jin') }}：</span>
            <span>{{ detail.rentalDeposit }}</span>
          </li>
          <li>
            <span class="label">{{ $t('crm_contract_info.sheng_xiao_ri_qi') }}：</span>
            <span>{{ $momentLocal(detail.effectiveDate, 'YYYY-MM-DD') || '/' }}</span>
          </li>
          <li>
            <span class="label">{{ $t('crm_contract_info.jfskyqts') }}：</span>
            <span>{{ detail.jvOverdueDays }}</span>
          </li>
          <li>
            <span class="label">{{ $t('crm_contract_info.zbskyqts') }}：</span>
            <span>{{ detail.hqOverdueDays }}</span>
          </li>
          <li style="width: 100%">
            <span class="label">{{ $t('crm_contract_info.shi_yong_di_zhi') }}：</span>
            <span>{{ detail.country || '' }}{{ detail.province || '' }}{{ detail.city != detail.province ? detail.city || '' : '' }}{{ detail.useAddress }}</span>
          </li>
        </ul>
      </div>
      <div class="item-company">
        <div class="ub">
          <div class="ub-f1">
            <h1 class="sub-title">{{ $t('crm_contract_info.jia_fang_xin_xi') }}</h1>
            <ul>
              <li>
                <span class="label">{{ $t('crm_contract_info.jfsqdb') }}</span>
                <span>{{ detail.partyAName }}</span>
              </li>
              <li>
                <span class="label">{{ $t('crm_contract_info.ye_wu_fu_ze_ren') }}</span>
                <span>{{ detail.salesman }}</span>
              </li>
              <li>
                <span class="label">{{ $t('crm_contract_info.lian_xi_dian_hua') }}</span>
                <span>{{ detail.salesmanPhone }}</span>
              </li>
              <li>
                <span class="label">{{ $t('crm_contract_info.sqdbdz') }}</span>
                <span>{{ detail.partyAAddress }}</span>
              </li>
            </ul>
          </div>
          <div class="ub-f1">
            <h1 class="sub-title">{{ $t('crm_contract_info.yi_fang_xin_xi') }}</h1>
            <ul style="margin-bottom: 24px">
              <li>
                <span class="label">{{ $t('crm_contract_info.yfgsmc') }}</span>
                <span>{{ detail.customerName }}</span>
              </li>
              <li>
                <div class="ub">
                  <div class="ub-f1">
                    <span class="label">{{ $t('crm_contract_info.xiang_mu_fu_ze_ren') }}</span>
                    <span>{{ detail.projectContactName }}</span>
                  </div>
                  <div class="ub-f1">
                    <span class="label">{{ $t('crm_contract_info.lian_xi_dian_hua') }}</span>
                    <span>{{ detail.projectContactPhone }}</span>
                  </div>
                </div>
              </li>
              <li>
                <div class="ub">
                  <div class="ub-f1">
                    <span class="label">{{ $t('crm_contract_info.shou_quan_dai_biao') }}</span>
                    <span>{{ detail.signerName }}</span>
                  </div>
                  <div class="ub-f1">
                    <span class="label">{{ $t('crm_contract_info.lian_xi_dian_hua') }}</span>
                    <span>{{ detail.signerPhone }}</span>
                  </div>
                </div>
              </li>
              <li>
                <div class="ub">
                  <div class="ub-f1">
                    <span class="label">{{ $t('crm_contract_info.fa_ren_xing_ming') }}</span>
                    <span>{{ detail.legalPerson }}</span>
                  </div>
                  <div class="ub-f1">
                    <span class="label">{{ $t('crm_contract_info.frsfzhm') }}</span>
                    <span>{{ detail.identityCard }}</span>
                  </div>
                </div>
              </li>
              <li>
                <span class="label">{{ $t('crm_contract_info.yi_fang_di_zhi') }}</span>
                <span>{{ detail.customerAddress }}</span>
              </li>
              <li>
                <span class="label">{{ $t('crm_contract_info.ji_tuan_gong_si') }}</span>
                <span>{{ detail.bigCustomerName }}</span>
              </li>
            </ul>
            <h1 class="sub-title">{{ $t('crm_contract_info.yfshxx') }}</h1>
            <ul>
              <li>
                <span class="label">{{ $t('crm_contract_info.shou_huo_ren') }}</span>
                <span v-if="detail.cdeliverAddress">{{ detail.cdeliverAddress.consigneeName }}</span>
              </li>
              <li>
                <span class="label">{{ $t('crm_contract_info.lian_xi_dian_hua') }}</span>
                <span v-if="detail.cdeliverAddress">{{ detail.cdeliverAddress.consigneePhone }}</span>
              </li>
              <li>
                <span class="label">{{ $t('crm_contract_info.shou_huo_di_zhi') }}</span>
                <span v-if="detail.cdeliverAddress">
                  {{ detail.cdeliverAddress.country || '' }}{{ detail.cdeliverAddress.province || ''
                  }}{{ detail.cdeliverAddress.city != detail.cdeliverAddress.province ? detail.cdeliverAddress.city || '' : '' }}{{ detail.cdeliverAddress.detailAddress || '' }}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="item-aftersale">
        <div class="ub">
          <div class="ub-f1">
            <h1 class="sub-title">{{ $t('crm_contract_info.shou_hou_zhong_xin') }}</h1>
            <ul>
              <li>
                <span class="label">{{ $t('crm_contract_info.shou_hou_gong_si') }}</span>
                <span>{{ detail.afterServiceName }}</span>
              </li>
              <li>
                <span class="label">{{ $t('crm_contract_info.shou_hou_fu_ze_ren') }}</span>
                <span>{{ detail.technicianName }}</span>
              </li>
              <li>
                <span class="label">{{ $t('crm_contract_info.shfzrdh') }}</span>
                <span>{{ detail.technicianPhone }}</span>
              </li>
              <!-- // 阿康说不好拿，砍掉该字段，那我可就手起刀落了
              <li>
                <span class="label">{{ $t('page_contract_shfjf') }}/{{ $t('page_contract_yue') }}</span>
                <span>{{ detail.afterServiceSurcharge }}</span>
              </li> -->
            </ul>
          </div>
          <div class="ub-f2">
            <h1 class="sub-title">{{ $t('crm_contract_info.shshxx') }}</h1>
            <ul>
              <li>
                <span class="label">{{ $t('crm_contract_info.shou_huo_ren') }}</span>
                <span v-if="detail.sdeliverAddress">{{ detail.sdeliverAddress.consigneeName }}</span>
              </li>
              <li>
                <span class="label">{{ $t('crm_contract_info.lian_xi_dian_hua') }}</span>
                <span v-if="detail.sdeliverAddress">{{ detail.sdeliverAddress.consigneePhone }}</span>
              </li>
              <li>
                <span class="label">{{ $t('crm_contract_info.shou_huo_di_zhi') }}</span>
                <span v-if="detail.sdeliverAddress">
                  {{ detail.sdeliverAddress.country || '' }}{{ detail.sdeliverAddress.province || ''
                  }}{{ detail.sdeliverAddress.city != detail.sdeliverAddress.province ? detail.sdeliverAddress.city || '' : '' }}{{ detail.sdeliverAddress.detailAddress || '' }}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="info-lease">
        <h1 class="sub-title">{{ $t('crm_contract_info.zu_lin_fang_an') }}</h1>
        <div class="pay-info">
          <!--
            甲方代表 总部一样 显示总部应收  显示 总部应收，金额取 甲方授权代表应收金额
            甲方代表 售后一样 显示甲方代表应收 显示甲方授权代表应收 金额取 甲方授权代表应收。

            1.甲方代表 总部一样 显示总部应收 显示 总部应收，金额取 甲方授权代表应收金额（firstTotal）
            2.甲方代表 售后一样 显示甲方代表应收 显示甲方授权代表应收 金额取 甲方授权代表应收（firstTotal）
            3.总部为售后服务公司时，显示 总部应收，无需显示售后应收，金额取(hqProfitTotal + serviceProfitTotal)
          -->
          <div v-if="detail.partyAId !== detail.hqId">
            {{ $t('crm_contract_info.jfsqdbys') }}：
            <span>{{schemeInfo.firstTotal }}</span>
          </div>
          <div>
            {{ $t('crm_contract_info.zong_bu_ying_shou') }}:
            <span v-if="detail.partyAId === detail.hqId&&detail.hqId !== detail.afterServiceId">{{ schemeInfo.firstTotal }}</span>
            <span v-else-if="detail.partyAId !== detail.hqId && detail.hqId === detail.afterServiceId">{{ parseFloat((schemeInfo.hqProfitTotal + schemeInfo.serviceProfitTotal).toFixed(2))  }}</span>
            <span v-else-if="detail.partyAId === detail.hqId && detail.hqId === detail.afterServiceId">{{  schemeInfo.firstTotal }}</span>
            <span v-else>{{ schemeInfo.hqProfitTotal }}</span>
          </div>
          <div v-if="detail.partyAId !== detail.afterServiceId && detail.hqId !== detail.afterServiceId">
            {{ $t('crm_contract_info.shou_hou_ying_shou') }}：
            <span>{{ schemeInfo.serviceProfitTotal }}</span>
          </div>
        </div>
        <custom-table :data="schemeList" :default-expand-all="true" expand tableCode="contractRentScheme">
          <template slot="expand" slot-scope="scope">
            <div class="ubw contract-scheme">
              <div>
                <p>{{ $t('crm_contract_info.zu_jin') }}/{{ getDicValue('rental_term_unit', scope.row.rentalTermUnit) }}</p>
                <p v-if="isDiscounted(scope.row)">
                  <span class="discount-rent">{{ getFinalRent(scope.row).toFixed(2) }}</span>
                  /
                  <del>{{ scope.row.unitPrice }}</del>
                </p>
                <p v-else>{{ scope.row.unitPrice }}</p>
              </div>
              <div>
                <p>{{ $t('crm_contract_info.swfdje') }}/{{ getDicValue('rental_term_unit', scope.row.rentalTermUnit) }}</p>
                <p class="discount-price">{{ getNumber(scope.row.discountPrice) }}</p>
              </div>
              <div>
                <p>{{ $t('crm_contract_info.shou_hou_fu_jia_fei') }}/{{ getDicValue('rental_term_unit', scope.row.rentalTermUnit) }}</p>
                <p>{{ scope.row.additionalFee }}</p>
              </div>
              <div>
                <p>{{ $t('crm_contract_info.ya_jin') }}/{{ $t('crm_contract_info.tai') }}</p>
                <p>{{ scope.row.depositFee }}</p>
              </div>
              <div>
                <p>{{ $t('crm_contract_info.fu_kuan_qi_shu') }}</p>
                <p>{{ computedNum(scope.row, 'periodNum') }}</p>
              </div>
              <div>
                <p>{{ $t('crm_contract_info.sqfcfa') }}</p>
                <p>{{ scope.row.sharingClass }}</p>
              </div>
              <div>
                <p>{{ $t('crm_contract_info.zbfhsl') }}</p>
                <p>{{ scope.row.hqDeliveryNum }}</p>
              </div>
              <div>
                <p>{{ $t('crm_contract_info.zbfhdshf') }}</p>
                <p>{{ getDicValue('crm_receiving_party', `${scope.row.hqShipTo}`) }}</p>
              </div>
              <div>
                <p>{{ $t('crm_contract_info.shou_qi_zu_jin') }}/{{ $t('crm_contract_info.tai') }}</p>
                <p>{{ computedNum(scope.row, 'firstRent') }}</p>
              </div>
              <div>
                <p>{{ $t('crm_contract_info.lei_ji_zu_jin') }}/{{ $t('crm_contract_info.tai') }}</p>
                <p>{{ computedNum(scope.row, 'totalRent') }}</p>
              </div>
              <div>
                <p>{{ $t('crm_contract_info.sqljzj') }}</p>
                <p>{{ computedNum(scope.row, 'firstRentTotal') }}</p>
              </div>
              <div>
                <p>{{ $t('crm_contract_info.lei_ji_ya_jin') }}</p>
                <p>{{ computedNum(scope.row, 'depositFeeTotal') }}</p>
              </div>
              <div>
                <p>{{ $t('crm_contract_info.sqkxzf') }}</p>
                <p>{{ computedNum(scope.row, 'firstPay') }}</p>
              </div>
            </div>
          </template>
          <!-- 操作列 -->
          <el-table-column :label="$t('Common.com_handle')" width="280" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="onPreviewDialog(scope.row)">{{ $t('crm_contract_info.ckfcmx') }}</el-button>
              <el-button type="text" size="mini" @click="onPreviewBreakDialog(scope.row)">{{ $t('crm_contract_info.ckwyfa') }}</el-button>
            </template>
          </el-table-column>
        </custom-table>
      </div>
      <div class="info-item">
        <h1 class="sub-title" style="margin-bottom: 0">{{ $t('crm_contract_info.he_tong_fu_jian') }}</h1>
        <div style="margin-top: 2px">
          <t-upload type="file" v-model="contractFile" :bizId="contractId" bizType="crm.contract" :disabled="true"></t-upload>
        </div>
      </div>
    </div>
    <!-- 查看分成 -->
    <step-manage-preview-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false"></step-manage-preview-dialog>
    <!-- 查看违约方案 -->
    <step-manage-falsify-dialog v-if="dialogVisible2" :model="dialogModel2" @close="dialogVisible2 = false"></step-manage-falsify-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import tUpload from '@/components/upload.vue';
import stepManagePreviewDialog from '@/pages/crm/components/managePreviewDialog.vue';
import stepManageFalsifyDialog from '@/pages/crm/contractLeaseItem/children/step_manage_falsify_dialog';

export default {
  components: { tUpload, stepManagePreviewDialog, stepManageFalsifyDialog },
  name: '',
  props: {
    detail: {
      type: Object,
      default() {
        return {};
      },
    },
    rule: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      dialogVisible1: false,
      dialogModel1: {},
      dialogVisible2: false,
      dialogModel2: {},

      contractId: '',
      contractClass: '',
      schemeList: [],
      schemeInfo: {},
      paymentInfo: {},
      certificateData: {},
      contractFile: [],
      classMap: {
        leasing_contract: 20, // 租赁合同
        lease_renewal_contract: 21, // 续租租赁
        frame_contract: 30, // 框架协议
        frame_order: 31, // 协议订单
        trail_order: 10, // 试用订单
      },
      approveMap: {
        20: 'leasing_contract', // 租赁合同
        21: 'lease_renewal_contract', // 续租合同
        30: 'frame_contract', // 框架协议
        31: 'frame_order', // 协议订单
        10: 'trail_order', // 试用订单
      },
      contractBizClass: ['20', '21', '30'], // 合同类型的bizClass
      orderBizClass: ['10', '31'], // 订单类型的bizClass
      bizClassType: '', // 合同contract,订单order
    };
  },
  mounted: function () {
    this.contractId = this.getJump('contractId');
    this.contractClass = this.getJump('contractClass');
    this.approveType = this.getJump('approveType');
    if (this.approveType && !this.contractClass) {
      this.contractClass = this.classMap[this.approveType];
    }
    if (!this.approveType && this.contractClass) {
      this.approveType = this.approveMap[this.contractClass];
    }
    if (this.contractBizClass.includes(`${this.contractClass}`)) {
      this.bizClassType = 'contract';
    }
    if (this.orderBizClass.includes(`${this.contractClass}`)) {
      this.bizClassType = 'order';
    }
    this.getListScheme();
  },
  methods: {
    // 将非数值统一按 0 处理，避免金额计算出现 NaN。
    getNumber(value) {
      const number = Number(value);
      return Number.isNaN(number) ? 0 : number;
    },
    // 最终租金等于原租金加上商务浮动金额。
    getFinalRent(row) {
      return this.getNumber(row.unitPrice) + this.getNumber(row.discountPrice);
    },
    // 租赁相关金额需要在最终租金基础上叠加售后附加费。
    getRentCost(row) {
      return this.getFinalRent(row) + this.getNumber(row.additionalFee);
    },
    isDiscounted(row) {
      return this.getNumber(row.discountPrice) !== 0;
    },
    // 租赁计算
    computedNum: function (row, name) {
      // 单台每期费用（最终租金 + 售后附加费）
      const cost = this.getRentCost(row);
      // 首期期数，一次性付清时取整个租赁周期
      const firstPeriod = this.getNumber(row.paymentPeriod) || this.getNumber(row.rentalTerm);
      const bookingNum = this.getNumber(row.bookingNum);
      const depositFeeTotal = this.getNumber(row.depositFee) * bookingNum;
      // 累计押金
      if (name === 'depositFeeTotal') {
        row.depositFeeTotal = depositFeeTotal.toFixed(2);
        return row.depositFeeTotal;
      }
      // 首期租金(合计)
      if (name === 'firstRentTotal') {
        row.firstRentTotal = (cost * firstPeriod * bookingNum).toFixed(2);
        return row.firstRentTotal;
      }
      // 首期需支付
      if (name === 'firstPay') {
        row.firstPay = (cost * firstPeriod * bookingNum + depositFeeTotal).toFixed(2);
        return row.firstPay;
      }
      // 租赁期数
      if (name === 'periodNum') {
        row.periodNum = Math.ceil(this.getNumber(row.rentalTerm) / (firstPeriod || 0));
        return row.periodNum;
      }
      // 首期租金/台
      if (name === 'firstRent') {
        row.firstRent = (cost * firstPeriod).toFixed(2);
        return row.firstRent;
      }
      // 累计租金/台
      if (name === 'totalRent') {
        row.totalRent = (cost * this.getNumber(row.rentalTerm)).toFixed(2);
        return row.totalRent;
      }
      return '';
    },
    // 首付款列表1
    getListScheme: function () {
      this.$getJSON(apis.crmContractListScheme, { bizId: this.contractId, bizClass: this.contractClass }).then((res) => {
        const data = res.data;
        const schemeList = data.goodsList || [];
        schemeList.forEach((i) => {
          i.hqShipTo = `${i.hqShipTo}`;
        });
        this.schemeList = schemeList;
        this.schemeInfo = data;
      });
    },
    // 查看分成预览
    onPreviewDialog: function (data) {
      this.dialogModel1.title = this.$t('crm_contract_info.ckfcmx');
      this.dialogModel1.data = { row: data, month: data.rentalTerm };
      this.dialogVisible1 = true;
    },
    // 查看违约方案
    onPreviewBreakDialog(data) {
      this.dialogModel2.type = 'watch';
      this.dialogModel2.title = this.$t('crm_contract_info.ckwyfa');
      this.dialogModel2.data = { row: data };
      this.dialogVisible2 = true;
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.contract-info-bd {
  background-color: #ffffff;
  .contract-scheme {
    > div {
      width: 180px;
      margin-bottom: 10px;
      > p:first-child {
        font-weight: 500;
        font-size: 12px;
      }
      p {
        line-height: 20px;
      }
    }
    // 商务浮动后的最终租金使用红色突出显示。
    .discount-rent {
      color: #f5222d;
      font-weight: bold;
    }
    // 商务浮动金额使用红色突出显示。
    .discount-price {
      color: #f5222d;
    }
  }
  .pay-info {
    display: flex;
    justify-content: flex-end;
    line-height: 36px;
    color: #495057;
    font-size: 12px;
    font-weight: 500;
    margin-top: 10px;
    & > div {
      margin-left: 20px;
      margin-right: 10px;
      span {
        color: red;
        font-size: 14px;
      }
    }
  }
  .title {
    line-height: 50px;
    height: 50px;
    padding-left: 20px;
    color: $title-color;
    font-weight: bold;
    font-size: 14px;
    border-bottom: 1px solid #eef2f8;
  }
  .info-wrap {
    padding: 20px 24px;
    .sub-title {
      color: $title-color;
      font-size: 12px;
      line-height: 32px;
      font-weight: 500;
      margin-bottom: 4px;
    }
    .item-onfo {
      border-bottom: 1px solid #eef2f8;
      padding: 0 16px 12px;
      ul > li {
        width: 33.3%;
      }
    }
    .item-company {
      padding: 12px 16px;
      border-bottom: 1px solid #eef2f8;
      & > .ub > .ub-f1:first-child {
        padding-right: 20px;
        border-right: 1px solid #eef2f8;
        margin-right: 16px;
      }
    }
    .item-aftersale,
    .item-firstpay {
      padding: 12px 16px;
      border-bottom: 1px solid #eef2f8;
      & > .ub > .ub-f2 {
        padding-left: 48px;
      }
    }
    .info-lease {
      padding: 12px 16px;
    }
    .info-item {
      padding: 12px 16px;
      .el-upload-list {
        display: flex;
      }
      .el-upload-list__item {
        background: rgba(248, 249, 251, 1);
        line-height: 32px;
        height: 32px;
        color: #0d9ae0;
        width: 306px;
        border-radius: 2px;
        padding: 0 10px;
        margin-right: 14px;
        margin-top: 0;
        &:first-child {
          margin-top: 0;
        }
        i.el-icon-document {
          display: none;
        }
        a.el-upload-list__item-name {
          color: #0d9ae0;
        }
        i.el-icon-circle-check::before {
          color: #0d9ae0;
          font-family: 'icon';
          font-size: 12px;
          font-style: normal;
          margin-right: 4px;
          -webkit-font-smoothing: antialiased;
          content: '\e6ec';
        }
      }
    }
    ul > li {
      line-height: 23px;
      // height: 23px;
      color: #6c757d;
      font-size: 12px;
      .label {
        color: #495057;
        width: 120px;
        display: inline-block;
        vertical-align: top;
      }
      a {
        text-decoration: underline;
      }
    }
  }
}
</style>
